// A short word at the bottom of the screen after something is done, with
// one action (Undo) while it shows. One at a time: a new one replaces it.
import htmlEntities from "../scripts/html-entities";

let current = null;

export function showToast(text, { action = '', onAction = null, error = false, ms = 9000 } = {}) {
  if(current) current.remove();
  const el = document.createElement('div');
  el.className = `ts-toast${error ? ' is-error' : ''}`;
  el.setAttribute('role', error ? 'alert' : 'status');
  el.innerHTML = `<span class="ts-toast__text">${htmlEntities(text)}</span>
    ${action ? `<button type="button" class="ts-toast__action">${htmlEntities(action)}</button>` : ''}
    <button type="button" class="ts-toast__close" aria-label="Close">×</button>`;
  document.body.appendChild(el);
  current = el;
  let timer = setTimeout(() => close(), ms);
  const close = () => {
    clearTimeout(timer);
    el.classList.add('is-leaving');
    setTimeout(() => el.remove(), 200);
    if(current === el) current = null;
  };
  // kept while the pointer is on it
  el.addEventListener('mouseenter', () => clearTimeout(timer));
  el.addEventListener('mouseleave', () => { timer = setTimeout(() => close(), 4000); });
  el.querySelector('.ts-toast__close').addEventListener('click', close);
  const btn = el.querySelector('.ts-toast__action');
  if(btn) {
    btn.addEventListener('click', () => {
      btn.disabled = true;
      close();
      if(onAction) onAction();
    });
  }
  return { close };
}
